/** Shared constants for the packaging-report rating page. */

export const RATING_SCALE = [1, 2, 3, 4, 5] as const;

/**
 * The same wording /rate shows, and shown under each button rather than in a tooltip — a rater
 * should not have to hover to learn what a 3 means, and a visible scale is what keeps scoring
 * consistent between people. Deliberately identical to the RLHF rubric so scores from the two
 * surfaces mean the same thing if they are ever compared.
 */
export const RATING_LABELS: Record<number, string> = {
  1: 'Very weak',
  2: 'Weak',
  3: 'Adequate',
  4: 'Strong',
  5: 'Excellent',
};

export const SCALE_HINTS: Record<number, string> = {
  1: 'Very weak — unusable as a deliverable',
  2: 'Weak — misses most of what a brand team needs',
  3: 'Adequate — partly lands',
  4: 'Strong — clear and well supported',
  5: 'Excellent — clear, evidenced and actionable',
};

/** Mirrors MAX_REMARKS_LENGTH on the backend so the limit is felt before a 422, not after. */
export const MAX_REMARKS_LENGTH = 5000;

/** Wide enough for a report designed at 1080px to keep its multi-column layout. */
export const CONTENT_MAX_WIDTH = 1140;
